'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCompass = function TiCompass(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 8.3c6.4 0 11.7 5.3 11.7 11.7 0 6.4-5.3 11.7-11.7 11.7-6.4 0-11.7-5.3-11.7-11.7s5.3-11.7 11.7-11.7z m0-3.3c-8.3 0-15 6.7-15 15 0 8.3 6.7 15 15 15 8.3 0 15-6.7 15-15 0-8.3-6.7-15-15-15z m7 8c-0.2-0.2-0.6-0.3-0.8-0.2l-10 2.9c-0.2 0-0.5 0.3-0.5 0.5l-2.9 10c-0.1 0.2 0 0.6 0.2 0.8 0.2 0.1 0.4 0.2 0.6 0.2 0.1 0 0.2 0 0.2 0l10-2.9c0.2 0 0.5-0.3 0.5-0.5l2.9-10c0.1-0.2 0-0.6-0.2-0.8z m-12.2 12.2l2.3-8.1 5.8 5.8-8.1 2.3z' })
        )
    );
};

exports.default = TiCompass;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/compass.js
// module id = 3593
// module chunks = 0